import React from "react";
import { Input } from "../../../components/Input";
import { Label } from "../../../components/Label";

import { BaseCurrencyInput, Hairline, Radio } from "@components";
import styles from "@styles/containers/cashback-programs/receive-remind.module.scss";

const st = (className) => styles[className];

export class RemindStep extends React.Component {
  emitChange() {
    const { cashbackProgram, onChange } = this.props;

    const newCashbackProgram = {
      ...cashbackProgram,
      expiration_message: {
        remind_days_before:
          cashbackProgram?.expiration_message?.remind_days_before,
        remind_hour: cashbackProgram?.expiration_message?.remind_hour,
      },
    };

    onChange(newCashbackProgram);
  }

  render() {
    const { onChangeRemind, enabledRemind, cashbackProgram } = this.props;

    return (
      <>
        <Label text="Deseja ativar lembrete de expiração?" className="mb-20" />
        <Radio
          family="reminder"
          onChange={() => onChangeRemind(true)}
          checked={enabledRemind}
          value={true}
        >
          <p className={st("radio-label")}>Sim</p>
        </Radio>
        <Radio
          family="reminder"
          onChange={() => onChangeRemind(false)}
          checked={enabledRemind}
          value={false}
          className="mt-10"
        >
          <p className={st("radio-label")}>Não</p>
        </Radio>

        {enabledRemind && (
          <>
            <Hairline />

            <Label text="Defina o período e a hora do disparo" />
            <div className="d-flex">
              <BaseCurrencyInput
                design="three"
                suffix={" dias antes"}
                prefix=""
                max={"### dias antes".length}
                precision={0}
                className="w-100 pt-0"
                value={cashbackProgram?.expiration_message?.remind_days_before}
                onChange={(value) => {
                  cashbackProgram.expiration_message.remind_days_before = value;

                  this.setState(
                    { cashbackProgram },
                    this.emitChange.bind(this)
                  );
                }}
              />
              <Input
                className="w-100 ml-15"
                design="three"
                type="time"
                value={cashbackProgram?.expiration_message?.remind_hour}
                onChange={(e) => {
                  cashbackProgram.expiration_message.remind_hour =
                    e.target.value;
                  this.setState(
                    { cashbackProgram },
                    this.emitChange.bind(this)
                  );
                }}
              />
            </div>
          </>
        )}
      </>
    );
  }
}
